import { render, staticRenderFns } from "./PhoneForm.vue?vue&type=template&id=bbc4d618&scoped=true&"
import script from "./PhoneForm.vue?vue&type=script&lang=js&"
export * from "./PhoneForm.vue?vue&type=script&lang=js&"
import style0 from "./PhoneForm.vue?vue&type=style&index=0&id=bbc4d618&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc4d618",
  null
  
)

export default component.exports